<template>

    <v-page>

        <v-page-header icon="fas fa-comment">
            <v-breadcrumb>
                <v-breadcrumb-item>Campaign Messages</v-breadcrumb-item>
            </v-breadcrumb>
        </v-page-header>

        <v-page-filters>
            <v-button-toolbar size="sm">
                <v-dropdown
                    prefix="Status"
                    :items="[
                        { key: '', value: 'Sent' },
                        { key: 'delivered', value: 'Delivered' },
                        { key: 'opened', value: 'Opened' },
                        { key: 'clicked', value: 'Clicked' },
                        { key: 'failed', value: 'Failed' },
                    ]"
                    :selected="params.status"
                    @change="onStatusSelected">
                </v-dropdown>
                <v-dropdown-timeframe
                    :selected="params.timeframe"
                    @change="onTimeframeSelected">
                </v-dropdown-timeframe>
            </v-button-toolbar>
            <div></div>
        </v-page-filters>

        <v-page-body>

            <v-stats :counts="stats" />

            <v-notice v-if="!messages.length" title="No Messages" message="There are no messages yet." />

            <v-page-section v-else padded>
                <template #title>
                    <span>{{ pagination | paginationTitle('Messages (', ')') }}</span>
                </template>
                <template #body>
                    <v-table scrollable>
                        <thead>
                            <th></th>
                            <th>Name</th>
                            <th>Channel</th>
                            <th>Sent</th>
                            <th>Delivered</th>
                            <th>Opened</th>
                            <th>Clicked</th>
                            <th>Failed</th>
                        </thead>
                        <tbody>
                            <tr v-for="m in messages" :key="m.id" @click="viewCustomer(m.customer_id)">
                                <td class="w-34 pr-0">
                                    <v-avatar
                                        :name="m.customer.initials"
                                        :color="m.customer.color"
                                        :url="m.customer.gravatar ? m.customer.gravatar + '&s=80' : ''"
                                        :size="34"
                                        :radius="17">
                                    </v-avatar>
                                </td>
                                <td><v-value :value="m.customer | valueForTrait({ field: 'name', type: 'string' })" /></td>
                                <td>{{ m.action ? m.action.type : 'email' }}</td>
                                <td v-if="m.sent_at">{{ m.sent_at | dateTime }}</td><td v-else>&mdash;</td>
                                <td v-if="m.delivered_at">{{ m.delivered_at | dateTime }}</td><td v-else>&mdash;</td>
                                <td v-if="m.opened_at">{{ m.opened_at | dateTime }}</td><td v-else>&mdash;</td>
                                <td v-if="m.clicked_at">{{ m.clicked_at | dateTime }}</td><td v-else>&mdash;</td>
                                <td v-if="m.failed_at">{{ m.failed_at | dateTime }}</td><td v-else>&mdash;</td>
                            </tr>
                        </tbody>
                    </v-table>
                </template>
                <template #footer>
                    <v-pagination :count="pagination.last_page" @search="paginateMessages($event)" />
                </template>
            </v-page-section>

        </v-page-body>

    </v-page>

</template>

<script>

import axios from 'axios';
import CampaignMessageApi from '@api/CampaignMessageApi';
import Stats from './components/Stats';

export default {

    components: {
        'v-stats': Stats,
    },

    data() {
        return {
            stats: {},
            messages: [],
            pagination: {},
            params: {
                campaign_id: this.$route.params.id,
            },
        }
    },

    mounted() {
        this.params = this.$route.query;
        this.reload();
    },

    watch: {

        $route(val) {
            this.params = val.query;
            this.reload();
        },

    },

    methods: {

        onTypeSelected(item) {
            let query = Object.assign({}, this.$route.query);
            query.type = item.key;
            query.page = 1;
            this.$router.replace({ query: query }).catch(() => {});
        },

        onStatusSelected(item) {
            let query = Object.assign({}, this.$route.query);
            query.status = item.key;
            query.page = 1;
            this.$router.replace({ query: query }).catch(() => {});
        },

        onTimeframeSelected(item) {
            let query = Object.assign({}, this.$route.query);
            query.timeframe = item.key;
            query.page = 1;
            this.$router.replace({ query: query }).catch(() => {});
        },

        reload() {
            this.$store.commit('loading', true);
            let params = Object.assign({}, this.params);
            params.campaign_id = this.$route.params.id;
            let requests = [
                CampaignMessageApi.getMessagesStats(params),
                CampaignMessageApi.getMessages(params),
            ];
            axios.all(requests)
                .then(axios.spread((resStats, resMessages) => {
                    this.$store.commit('loading', false);
                    this.stats = resStats.data.data;
                    this.messages = resMessages.data.data;
                    this.pagination = resMessages.data.pagination;
                    this.$events.$emit('pageLoaded');
                }), () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        paginateMessages(page) {
            let query = Object.assign({}, this.$route.query);
            query.page = page;
            this.$router.replace({ query: query }).catch(() => {});
        },

        viewCustomer(customerId) {
            this.$router.push({
                name: 'customer',
                params: { id: customerId },
            });
        },

    },

}

</script>
